export const JITSI_HANGUP = 'JITSI/HANGUP'
export const JITSI_MEET = 'JITSI/MEET'
export const JITSI_TOGGLE_CHAT = 'JITSI/TOGGLE_CHAT'
export const JITSI_MEET_ROOM_DETAILS = 'JITSI/MEET_ROOM_DETAILS'
export const JITSI_REQUEST_AUTO_JOIN = 'JITSI/REQUEST_AUTO_JOIN'
export const JITSI_VIDEO_CONFERENCE_JOINED = 'JITSI/VIDEO_CONFERENCE_JOINED'

export interface HangupAction {
    type: typeof JITSI_HANGUP;
}

export interface MeetAction {
    channel_id: string;
    type: typeof JITSI_MEET;
}

export interface MeetRoomDetailsAction {
    jitsi_room: string;
    jitsi_token: string;
    type: typeof JITSI_MEET_ROOM_DETAILS;
}

export interface ToggleChatAction {
    type: typeof JITSI_TOGGLE_CHAT;
}

export interface VideoConferenceJoinedAction {
    type: typeof JITSI_VIDEO_CONFERENCE_JOINED;
    joined: boolean;
}

export interface RequestAutoJoinAction {
    channel_id: string;
    type: typeof JITSI_REQUEST_AUTO_JOIN;
}

export type JitsiActionTypes =
    | HangupAction
    | MeetAction
    | ToggleChatAction
    | MeetRoomDetailsAction
    | RequestAutoJoinAction
    | VideoConferenceJoinedAction
